<template>
	<el-date-picker
		v-model="myValue"
		type="datetime"
		format="yyyy-MM-dd HH:mm:ss"
		:default-time="'00:00:00'"
		value-format="timestamp"
		placeholder="选择日期时间"
		:picker-options="pickerOptions"
		v-if="params.type=='ts'"
	></el-date-picker>
	<el-date-picker
		v-model="myValue"
		type="date"
		format="yyyy-MM-dd"
		:default-time="'00:00:00'"
		value-format="timestamp"
		placeholder="选择日期时间"
		:picker-options="pickerOptions"
		v-else
	></el-date-picker>
</template>

<script>
export default {
	data() {
		return {
			pickerOptions: {
				shortcuts: [
					{
						text: "清空",
						onClick(picker) {
							picker.$emit("pick", null);
						},
					},
					{
						text: "今天",
						onClick(picker) {
							picker.$emit("pick", new Date());
						},
					},
					{
						text: "昨天",
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24);
							picker.$emit("pick", date);
						},
					},
					{
						text: "一周前",
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit("pick", date);
						},
					},
				],
			},
		};
	},
	computed: {
		myValue: {
			get: function() {
				if (!this.value) {
					const date = new Date();
					return date.getTime();
				} else {
					return this.value * 1000;
				}
			},
			set: function(newValue) {
				this.$emit("input", Math.round(newValue / 1000));
				this.$emit("change", Math.round(newValue / 1000));
			},
		},
	},
	created() {},
	mounted() {},
	methods: {},
	props: {
		value: {
			type: Number,
		},
		params: {
			type: Object,
			default: function() {
				return {
					type: "ts",
				};
			},
		},
	},
	watch: {
		value: function(val) {},
	},
	components: {},
};
</script>
<style lang="scss" scoped>
</style>
